module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-sleepy.9d5a3ca8.png";